export default __webpack_public_path__ + "static/media/frame-5.510b8be1.png";